import SelectModalClass from "../common/SelectModalClass";
import RippleManagerClass from "../common/RippleManagerClass";
import Util from "../../libs/util/Util";
import LtikeCommon from "../common/LtikeCommon";

/**
 * 空港選択時のモーダル
 */
export default class AirportSelectModalClass extends SelectModalClass{
    constructor(_target,_parent){
        super(_target,_parent);
        this.name = "AirportSelectModalClass";

        this.CL_ACTIVE = "isActive";
        this.CL_MODAL_HEIGHT_AUTO = "isModalHeightAuto";

        this.tmpRipple = null;

        this.code = null;

        this.defaultList = LtikeCommon.AIRPLANE.DEFAULT_AIRPORT_LIST.NORMAL;
        this.recommendData = LtikeCommon.AIRPLANE.DEFAULT_AIRPORT_LIST.POPULAR;
    }

    onCreate() {
        super.onCreate();
        this.insertTarget = $(".wrap",this.modal);
    }

    onResize(_size){
        super.onResize(_size);
        if(this.tmpRipple){
            this.tmpRipple.onResize(_size);
        }
    }

    onSetData(_data){
        this.code = _data.code;
        this.onSetClickTargetText(_data.namej);

        this.onActiveChange();
    }

    onClickSelect(e) {
        this.code = $(e.currentTarget).attr("data-id");
        this.onActiveChange();
        super.onClickSelect(e);
    }

    onActiveChange(){
        $(".text",this.clickTarget).attr({"data-id":this.code});
        $("a",this.list).removeClass(this.CL_ACTIVE);
        if(this.code !== "") $("a",this.list).filter('[data-id='+this.code+']').addClass(this.CL_ACTIVE);
    }

    onSetDefaultSelect(){
        let airportList = [];

        airportList[0] = {
            ttl:LtikeCommon.AIRPLANE.TEXT.MODAL_AIRPORT_POPULAR_TITLE,
            items:[]
        };

        for(let k in this.recommendData){
            const d = this.recommendData[k];
            let obj = Util.MASTER_AIRPORT_DATA[d];
            airportList[0].items.push(obj);
        }

        //console.log(Util.MASTER_AIRPORT_DATA);
        const airportData = Util.MASTER_AIRPORT_DATA;
        for(let k in airportData){
            const d = airportData[k];
            if(!airportList[d.areacode]) {
                airportList[d.areacode] = {
                    ttl:d.areaname,
                    items:[]
                };
            }
            airportList[d.areacode].items.push(d);
        }
        //console.log("onSetDefaultSelect");

        const html = this.getListHtml(airportList);
        this.insertTarget.html(html);
        this.list = $("li",this.modal);
        $("a",this.list).on("click",this.onClickSelectListerner);
        this.tmpRipple = new RippleManagerClass(this.modal);
        this.tmpRipple.onCreate();
        this.tmpRipple.onResize(Util.getWindowSize());
    }

    onResetSelect(){
        this.insertTarget.empty();
        this.onSetDefaultSelect();
    }

    onSetSelect(_data){
        let flag = false;
        let airportList = [];
        for(let k in _data){
            const d = _data[k];
            if(d.code === this.code){
                flag = true;
            }

            let obj = Util.MASTER_AIRPORT_DATA[d.code];
            if(!airportList[obj.areacode]) {
                airportList[obj.areacode] = {
                    ttl:obj.areaname,
                    items:[]
                };
            }
            airportList[obj.areacode].items.push(obj);
        }

        //console.log("onSetSelect",_data,airportList);

        this.insertTarget.empty();
        if(!flag){
            $(".text",this.clickTarget).attr({"data-id":""});
            this.onSetClickTargetText(LtikeCommon.AIRPLANE.TEXT.MODAL_AIRPORT_DEFAULT);
        }

        const html = this.getListHtml(airportList);
        this.insertTarget.html(html);

        this.list = $("li",this.modal);
        $("a",this.list).on("click",this.onClickSelectListerner);

        if(!Util.isBreakpoint){
            if(this.list.length <= 9){
                this.modal.addClass(this.CL_MODAL_HEIGHT_AUTO);
            } else {
                this.modal.removeClass(this.CL_MODAL_HEIGHT_AUTO);
            }
        }

        this.tmpRipple = new RippleManagerClass(this.modal);
        this.tmpRipple.onCreate();
        this.tmpRipple.onResize(Util.getWindowSize());

        if(flag) this.onActiveChange();
    }

    getListHtml(_list){
        let html = '';
        for(let k in _list){
            let d = _list[k];
            html += '<div class="block"><h3>'+d.ttl+'</h3><ul>';

            for(let a in d.items){
                let item = d.items[a];
                html += '<li><a href="" class="js-ripple" data-id="'+item.code+'">'+item.namej+'</a></li>';
            }
            html += '</ul></div>';
        }
        return html;
    }
}